/**
 * Authentication API using Orval-generated client
 */
import { authControllerAuthenticateTelegram } from '@/generated/api/auth/auth';
import type { AuthTokenResponseDto, TelegramAuthDto } from '@/generated/api/model';
import { apiClient } from './client';
import { config } from '../utils/config';
import { getTelegramInitData } from '../utils/telegram';

export const authApi = {
  /**
   * Authenticate with Telegram WebApp or dev mode
   */
  async login(): Promise<AuthTokenResponseDto> {
    const initData = getTelegramInitData();

    const payload: TelegramAuthDto = {};

    // Use Telegram init data if available
    if (initData) {
      payload.initData = initData;
    }
    // Fall back to dev mode if enabled
    else if (config.devAuth && config.devUserId) {
      payload.devUserId = config.devUserId;
    } else {
      throw new Error('No authentication method available');
    }

    const response = await authControllerAuthenticateTelegram(payload);

    // Extract data from Orval response wrapper
    const data = 'data' in response ? response.data : response;

    // Store token in client
    if (data && typeof data === 'object' && 'accessToken' in data) {
      apiClient.setToken(data.accessToken as string);
    }

    return data as AuthTokenResponseDto;
  },

  /**
   * Logout
   */
  logout(): void {
    apiClient.clearToken();
  },

  /**
   * Check if authenticated
   */
  isAuthenticated(): boolean {
    return apiClient.isAuthenticated();
  },

  /**
   * Get current token
   */
  getToken(): string | null {
    return apiClient.getToken();
  },
};
